<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Update Sortition
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <result-api-user-form
              ref="form"
              v-model="user"
              :params="params"
              @submit="update"
              is-update
            >
            </result-api-user-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="$router.push($routes.admin.resultApiUser.indexRoute)"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ResultApiUserCreateUpdate from "./ResultApiUserCreateUpdate";
import { updateUser, fetchUser } from "../../../../api/resultApiUser.api.js";

export default {
  name: "ResultApiUserUpdate",
  extends: ResultApiUserCreateUpdate,
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  watch: {
    $route() {
      this.$startLoading();
      this.fetchUser(this.id);
      this.$finishedLoading();
    }
  },
  async mounted() {
    this.$startLoading();
    await this.fetchUser(this.id);
    this.$finishedLoading();
  },
  methods: {
    update() {
      const { user, $routes, $router, $refs } = this;

      updateUser(this.id, user)
        .then(() => {
          $router.push({ name: $routes.admin.resultApiUser.indexRoute.name });
        })
        .catch(error =>
          this.handleErrorResponse($refs.validationObserver, error)
        );
    },
    async fetchUser(userID) {
      try {
        const { data } = await fetchUser(userID),
          { user } = data;

        this.user = user;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped></style>
